"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    Title2: function() {
        return _index.Title2;
    },
    title2ClassNames: function() {
        return _index.title2ClassNames;
    }
});
const _index = require("./components/presets/Title2/index");
